import { DocumentType, PatchedShipmentUpdate, useApiLogisticsShipmentsPartialUpdate } from 'api';

import { useUploadAndCreateShipmentDocument } from './useUploadAndCreateShipmentDocument';

export const useUpdateShipment = () => {
  const uploadAndCreateDocument = useUploadAndCreateShipmentDocument();
  const { mutateAsync: updatePartialShipment, ...rest } = useApiLogisticsShipmentsPartialUpdate();

  const updateShipment = async (
    bookingConfirmation: File | null = null,
    data: PatchedShipmentUpdate,
    shipmentName: string | undefined
  ) => {
    if (!shipmentName) {
      throw new Error('No specified shipment name');
    }
    await updatePartialShipment({ data, name: shipmentName });
    if (bookingConfirmation) {
      await uploadAndCreateDocument(
        {
          file: bookingConfirmation,
          type: DocumentType.BC,
        },
        { name: shipmentName }
      );
    }
  };

  return {
    updateShipment,
    ...rest,
  };
};
